"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDA = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const web3_js_1 = require("@solana/web3.js");
class PDA {
    constructor(programId) {
        this.config = () => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("config")], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.treasury = () => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("treasury")], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.flexibleStakingAccount = (user) => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("flexible_staking_account"), user.toBuffer()], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.flexibleStakingAccountV2 = (mint, user) => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("flexible_staking_account"), mint.toBuffer(), user.toBuffer()], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.flexibleVault = () => {
            const config = this.config().key;
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("flexible_vault"), config.toBuffer()], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.flexibleVaultV2 = (mint) => {
            const config = this.config().key;
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("flexible_vault"), config.toBuffer(), mint.toBuffer()], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.user = (user) => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("user"), user.toBuffer()], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.userV2 = (mint, user) => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("user"), mint.toBuffer(), user.toBuffer()], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.lockupStakingAccount = (user, index, vaultIndex, mint) => {
            const lockupVault = mint ? this.lockupVaultV2(mint, vaultIndex).key : this.lockupVault(vaultIndex).key;
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("lockup_staking_account"), user.toBuffer(), lockupVault.toBuffer(), Buffer.from(index.toArray("le", 4))], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.lockupVault = (index) => {
            const config = this.config().key;
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("lockup_vault"), config.toBuffer(), Buffer.from(index.toArray("le", 2))], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.lockupVaultV2 = (mint, index) => {
            const config = this.config().key;
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("lockup_vault"), config.toBuffer(), mint.toBuffer(), Buffer.from(index.toArray("le", 2))], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.withdrawPosition = (user, index) => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("withdraw_position"), user.toBuffer(), Buffer.from(index.toArray("le", 4))], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.withdrawPositionV2 = (mint, user, index) => {
            const [pda, bump] = web3_js_1.PublicKey.findProgramAddressSync([anchor_1.utils.bytes.utf8.encode("withdraw_position"), mint.toBuffer(), user.toBuffer(), Buffer.from(index.toArray("le", 4))], this.programId);
            return {
                key: pda,
                bump,
            };
        };
        this.programId = programId;
    }
}
exports.PDA = PDA;
